import ENDPOINTS from '../../../constants/apiEndPoints';
import { axiosInstance } from '../../axiosInstance';

export const handleCreateAnnouncementService = async (
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.GET_CREATE_ANNOUNCEMENT,
    payload,
  );
  return response?.data;
};

export const handleGetAllAnnouncementsService = async (
  params: Record<string, any>,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_ANNOUNCEMENT, {
    params,
  });
  return response?.data;
};

export const handleGetAnnouncementsByIdsService = async (
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.GET_ANNOUNCEMENTS_BY_IDS,
    payload,
  );
  return response?.data;
};

export const handleGetAnnouncementStatsService = async (
  params: Record<string, any>,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_ANNOUNCEMENT_STATS, {
    params,
  });
  return response?.data;
};

export const handleUpdateAnnouncementService = async (
  id: string,
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.GET_UPDATE_DELETE_ANNOUNCEMENT(id),
    payload,
  );
  return response.data;
};

export const handleGetAllAnnouncementsByDateService = async (
  date: string,
  params: Record<string, any>,
) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_ALL_ANNOUNCEMENTS_BY_DATE(date),
    { params },
  );
  return response?.data;
};

export const handleDeleteAnnouncementService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.GET_UPDATE_DELETE_ANNOUNCEMENT(id),
  );
  return response.data;
};

export const handleBulkDeleteAnnouncementsService = async (
  announcementIds: string[],
) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.BULK_DELETE_ANNOUNCEMENTS,
    {
      data: { announcementIds },
    },
  );
  return response.data;
};

export const handleSoftDeleteAnnouncementService = async (
  id: string,
  screen: string,
) => {
  const response = await axiosInstance.patch(
    ENDPOINTS.SOFT_DELETE_ANNOUNCEMENT(id),
    { screen },
  );
  return response.data;
};

export const handleUpdateAnnouncementTaskService = async (
  id: string,
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.UPDATE_DELETE_ANNOUNCEMENT_TASK(id),
    payload,
  );
  return response.data;
};

export const handleDeleteAnnouncementTaskService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.UPDATE_DELETE_ANNOUNCEMENT_TASK(id),
  );
  return response.data;
};

export const handleCreateAnnouncementTaskCommentService = async (
  id: string,
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.CREATE_ANNOUNCEMENT_TASK_COMMENT(id),
    payload,
  );
  return response.data;
};

export const handleUpdateAnnouncementTaskCommentService = async (
  id: string,
  payload: Record<string, any>,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.UPDATE_DELETE_ANNOUNCEMENT_TASK_COMMENT(id),
    payload,
  );
  return response.data;
};

export const handleDeleteAnnouncementTaskCommentService = async (
  id: string,
) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.UPDATE_DELETE_ANNOUNCEMENT_TASK_COMMENT(id),
  );
  return response.data;
};

export const handleGetBriefAnnouncementsService = async (
  params: Record<string, any>,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_BRIEF_ANNOUNCEMENT, {
    params,
  });
  return response?.data;
};

export const handleToggleAnnouncementResponderService = async (id: string) => {
  const response = await axiosInstance.post(
    ENDPOINTS.TOGGLE_ANNOUNCEMENT_RESPONDER(id),
  );
  return response?.data;
};

export const handleGetAnnouncementService = async (id: string) => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_UPDATE_DELETE_ANNOUNCEMENT(id),
  );
  return response?.data;
};

export const handleReadAnnouncementService = async (
  id: string,
  payload: { userId?: string },
) => {
  const response = await axiosInstance.post(
    ENDPOINTS.READ_ANNOUNCEMENT(id),
    payload,
  );
  return response?.data;
};

export const handleGetBriefGroupAnnouncementsService = async (
  date: string,
  params: Record<string, any>,
) => {
  const url = `${ENDPOINTS.GET_BRIEF_GROUP_ANNOUNCEMENT}/${date}`;
  const response = await axiosInstance.get(url, {
    params,
  });
  return response?.data;
};
